import { css } from '@emotion/react';
import { FC } from 'react';
import { StepperProps } from './Stepper';
import { useStepper } from './useStepper';

type StepperTrackProps = StepperProps;

const trackStyle = () => (theme) => {
  return css(theme.stepper.track);
};

const filledTrackStyle = () => (theme) => {
  return css(theme.stepper.filledTrack);
};

const trackPointerStyle = () => (theme) => {
  return css(theme.stepper.trackPointer);
};

export const StepperTrack: FC<StepperTrackProps> = ({
  activeStep,
  steps,
}: StepperTrackProps) => {
  const { stepSize, progressSize } = useStepper(steps.length, activeStep);

  return (
    <div
      css={trackStyle()}
      style={{
        width: `${stepSize * (steps.length - 1)}%`,
      }}
    >
      <div css={filledTrackStyle()} style={{ width: `${progressSize}%` }}>
        <div
          css={trackPointerStyle()}
          style={{ left: `${progressSize}%` }}
        ></div>
      </div>
    </div>
  );
};
